import React, { useState, useEffect } from 'react'
import Card from 'react-bootstrap/esm/Card'
import ReactPlaceholder from 'react-placeholder/lib'
import Helpers from '../../Components/Helpers/Helpers'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'
import { useSelector } from 'react-redux'

const DashboardAccount = () => {
  const [userData, setUserData] = useState({})
  const [ready, setReady] = useState(false)

  const session_user = useSelector(state => state.session)
  console.log('session_user', session_user)

  useEffect(() => {
    // Simular carga de datos del usuario
    setReady(true)
    setUserData({
      fullName: session_user.full_name,
      id_customers: session_user.username,
      registrationDate: ''
    })
  }, [])

  return (
    <div>
      {/* Header - Información del Usuario (Fondo blanco, sin Card) */}
      <div className="mb-4">
        <ReactPlaceholder ready={ready} showLoadingAnimation rows={3}>
          <div className="d-flex align-items-center">
            {/* Avatar del usuario */}
            {/* <div className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center mr-3"
              style={{ width: '60px', height: '60px', fontSize: '24px', fontWeight: 'bold' }}>
              {userData.initials}
            </div> */}

            {/* Información del usuario */}
            <div className="flex-grow-1">
              <h4 className="mb-1 font-weight-bold text-dark">{userData.fullName}</h4>
              <div className="d-flex align-items-center mb-2">
                <span className="text-dark me-2">#{userData.id_customers}</span>
              </div>
            </div>
          </div>
        </ReactPlaceholder>
      </div>

      {/* <div className="mb-4">
        <span className="text-muted">Registrado el {userData.registrationDate}</span>
      </div> */}

      {/* Contenido principal (Fondo gris claro) */}
      <div>
        <div>
          {/* Sección: La cuenta */}
          <div className="mb-5">
            <h5 className="text-primary mb-4 fw-bold">La cuenta</h5>
            <div className="row">
              {/* Información personal */}
              <div className="col-lg-4 col-md-6 mb-4">
                <Link to={Helpers.config.convertUrl({ url: '/informacion-personal' })} className="text-decoration-none">
                  <Card className="h-100 border-0 shadow-sm bg-white">
                    <Card.Body className="p-4">
                      <div className="d-flex align-items-center justify-content-between">
                        <h6 className="mb-0 fw-bold text-dark">Información personal</h6>
                        <i className="fas fa-user text-primary" style={{ fontSize: '24px' }}></i>
                      </div>
                    </Card.Body>
                  </Card>
                </Link>
              </div>

              {/* Mis documentos */}
              <div className="col-lg-4 col-md-6 mb-4">
                <Link to={Helpers.config.convertUrl({ url: '/direcciones-envio' })} className="text-decoration-none">
                  <Card className="h-100 border-0 shadow-sm bg-white">
                    <Card.Body className="p-4">
                      <div className="d-flex align-items-center justify-content-between">
                        <h6 className="mb-0 fw-bold text-dark">Mis Direcciones</h6>
                        <i className="fas fa-file-alt text-primary" style={{ fontSize: '24px' }}></i>
                      </div>
                    </Card.Body>
                  </Card>
                </Link>
              </div>
              
              <div className="col-lg-4 col-md-6 mb-4">
                <Link to={Helpers.config.convertUrl({ url: '/archivos' })} className="text-decoration-none">
                  <Card className="h-100 border-0 shadow-sm bg-white">
                    <Card.Body className="p-4">
                      <div className="d-flex align-items-center justify-content-between">
                        <h6 className="mb-0 fw-bold text-dark">Mis documentos</h6>
                        <i className="fas fa-file-alt text-primary" style={{ fontSize: '24px' }}></i>
                      </div>
                    </Card.Body>
                  </Card>
                </Link>
              </div>

              <div className="col-lg-4 col-md-6 mb-4">
                <Link to={Helpers.config.convertUrl({ url: '/suscripciones' })} className="text-decoration-none">
                  <Card className="h-100 border-0 shadow-sm bg-white">
                    <Card.Body className="p-4">
                      <div className="d-flex align-items-center justify-content-between">
                        <h6 className="mb-0 fw-bold text-dark">Mis Suscripciones</h6>
                        <i className="fas fa-file-alt text-primary" style={{ fontSize: '24px' }}></i>
                      </div>
                    </Card.Body>
                  </Card>
                </Link>
              </div>

              {/* Cambiar contraseña */}
              <div className="col-lg-4 col-md-6 mb-4">
                <Link to={Helpers.config.convertUrl({ url: '/informacion-personal' })} className="text-decoration-none">
                  <Card className="h-100 border-0 shadow-sm bg-white">
                    <Card.Body className="p-4">
                      <div className="d-flex align-items-center justify-content-between mb-3">
                        <h6 className="mb-0 fw-bold text-dark">Cambiar contraseña</h6>
                        <i className="fas fa-key text-primary" style={{ fontSize: '24px' }}></i>
                      </div>
                      <small className="text-muted">Las contraseñas se gestionan fuera de la Oficina PM.</small>
                    </Card.Body>
                  </Card>
                </Link>
              </div>

              {/* Métodos de pago */}
              {/* <div className="col-lg-4 col-md-6 mb-4">
                <a href="/perfil/metodos-pago" className="text-decoration-none">
                  <Card className="h-100 border-0 shadow-sm bg-white">
                    <Card.Body className="p-4">
                      <div className="d-flex align-items-center justify-content-between mb-3">
                        <h6 className="mb-0 fw-bold text-dark">Métodos de pago</h6>
                        <i className="fas fa-credit-card text-primary" style={{ fontSize: '24px' }}></i>
                      </div>
                      <small className="text-muted">Gestiona tus instrumentos de pago en PM Pagos.</small>
                    </Card.Body>
                  </Card>
                </a>
              </div> */}

              {/* Pagos */}
              <div className="col-lg-4 col-md-6 mb-4">
                <Link to={Helpers.config.convertUrl({ url: '/mis-pagos' })} className="text-decoration-none">
                  <Card className="h-100 border-0 shadow-sm bg-white">
                    <Card.Body className="p-4">
                      <div className="d-flex align-items-center justify-content-between mb-3">
                        <h6 className="mb-0 fw-bold text-dark">Pagos</h6>
                        <i className="fas fa-wallet text-primary" style={{ fontSize: '24px' }}></i>
                      </div>
                      <small className="text-muted">Elige cómo recibir tus comisiones y bonificaciones.</small>
                    </Card.Body>
                  </Card>
                </Link>
              </div>

              {/* Mis pedidos */}
              <div className="col-lg-4 col-md-6 mb-4">
                <Link to={Helpers.config.convertUrl({ url: '/historial-compras' })} className="text-decoration-none">
                  <Card className="h-100 border-0 shadow-sm bg-white">
                    <Card.Body className="p-4">
                      <div className="d-flex align-items-center justify-content-between mb-3">
                        <h6 className="mb-0 fw-bold text-dark">Mis pedidos</h6>
                        <i className="fas fa-receipt text-primary" style={{ fontSize: '24px' }}></i>
                      </div>
                      <small className="text-muted">Acceda a la lista completa que contiene todos los pedidos realizados a través de las páginas de eventos, la tienda virtual u otros métodos sin conexión compatibles.</small>
                    </Card.Body>
                  </Card>
                </Link>
              </div>
            </div>
          </div>

          {/* Sección: Recompensas */}
          <div className="mb-5">
            <h5 className="text-primary mb-4 fw-bold">Recompensas</h5>
            <div className="row">
              {/* Comisiones (Residual) */}
              <div className="col-lg-4 mb-4">
                <Link to={Helpers.config.convertUrl({ url: '/comisiones' })} className="text-decoration-none">
                  <Card className="h-100 border-0 shadow-sm bg-white">
                    <Card.Body className="p-4">
                      <div className="d-flex align-items-center justify-content-between">
                        <h6 className="mb-0 fw-bold text-dark">Comisiónes (Residual)</h6>
                        <i className="fas fa-user-plus text-primary" style={{ fontSize: '24px' }}></i>
                      </div>
                    </Card.Body>
                  </Card>
                </Link>
              </div>

              <div className="col-lg-4 mb-4">
                <Link to={Helpers.config.convertUrl({ url: '/historial-comisiones' })} className="text-decoration-none">
                  <Card className="h-100 border-0 shadow-sm bg-white">
                    <Card.Body className="p-4">
                      <div className="d-flex align-items-center justify-content-between">
                        <h6 className="mb-0 fw-bold text-dark">Comisiónes Histórico</h6>
                        <i className="fas fa-user-plus text-primary" style={{ fontSize: '24px' }}></i>
                      </div>
                    </Card.Body>
                  </Card>
                </Link>
              </div>

              <div className="col-lg-4 mb-4">
                <Link to={Helpers.config.convertUrl({ url: '/roll-over' })} className="text-decoration-none">
                  <Card className="h-100 border-0 shadow-sm bg-white">
                    <Card.Body className="p-4">
                      <div className="d-flex align-items-center justify-content-between">
                        <h6 className="mb-0 fw-bold text-dark">Colocación</h6>
                        <i className="fas fa-user-plus text-primary" style={{ fontSize: '24px' }}></i>
                      </div>
                    </Card.Body>
                  </Card>
                </Link>
              </div>

              {/* Bonos Rapidos */}
              <div className="col-lg-4 mb-4">
                <Link to={Helpers.config.convertUrl({ url: '/bonos' })} className="text-decoration-none">
                  <Card className="h-100 border-0 shadow-sm bg-white">
                    <Card.Body className="p-4">
                      <div className="d-flex align-items-center justify-content-between">
                        <h6 className="mb-0 fw-bold text-dark">Bonos Suscripción</h6>
                        <i className="fas fa-bolt text-primary" style={{ fontSize: '24px' }}></i>
                      </div>
                    </Card.Body>
                  </Card>
                </Link>
              </div>

              <div className="col-lg-4 mb-4">
                <Link to={Helpers.config.convertUrl({ url: '/bonos-periodo' })} className="text-decoration-none">
                  <Card className="h-100 border-0 shadow-sm bg-white">
                    <Card.Body className="p-4">
                      <div className="d-flex align-items-center justify-content-between">
                        <h6 className="mb-0 fw-bold text-dark">Bonos Periodo</h6>
                        <i className="fas fa-bolt text-primary" style={{ fontSize: '24px' }}></i>
                      </div>
                    </Card.Body>
                  </Card>
                </Link>
              </div>

              <div className="col-lg-4 mb-4">
                <Link to={Helpers.config.convertUrl({ url: '/reporte-bono-cedea-cliente' })} className="text-decoration-none">
                  <Card className="h-100 border-0 shadow-sm bg-white">
                    <Card.Body className="p-4">
                      <div className="d-flex align-items-center justify-content-between">
                        <h6 className="mb-0 fw-bold text-dark">Bonos CEDEA</h6>
                        <i className="fas fa-bolt text-primary" style={{ fontSize: '24px' }}></i>
                      </div>
                    </Card.Body>
                  </Card>
                </Link>
              </div>

              <div className="col-lg-4 mb-4">
                <Link to={Helpers.config.convertUrl({ url: '/mis-clientes-nuevos' })} className="text-decoration-none">
                  <Card className="h-100 border-0 shadow-sm bg-white">
                    <Card.Body className="p-4">
                      <div className="d-flex align-items-center justify-content-between">
                        <h6 className="mb-0 fw-bold text-dark">Clientes Nuevos</h6>
                        <i className="fas fa-bolt text-primary" style={{ fontSize: '24px' }}></i>
                      </div>
                    </Card.Body>
                  </Card>
                </Link>
              </div>

              <div className="col-lg-4 mb-4">
                <Link to={Helpers.config.convertUrl({ url: '/reporte-ecommerce-publico' })} className="text-decoration-none">
                  <Card className="h-100 border-0 shadow-sm bg-white">
                    <Card.Body className="p-4">
                      <div className="d-flex align-items-center justify-content-between">
                        <h6 className="mb-0 fw-bold text-dark">Ecommerce Publico</h6>
                        <i className="fas fa-bolt text-primary" style={{ fontSize: '24px' }}></i>
                      </div>
                    </Card.Body>
                  </Card>
                </Link>
              </div>

              {/* Tienda Virtual al Publico */}
              <div className="col-lg-4 mb-4">
                <a href={Helpers.config.convertUrl({
                  url: '/ecommerce-publico/' + userData.id_customers
                })} rel="noreferrer" target='_blank' className="text-decoration-none">
                  <Card className="h-100 border-0 shadow-sm bg-white">
                    <Card.Body className="p-4">
                      <div className="d-flex align-items-center justify-content-between">
                        <h6 className="mb-0 fw-bold text-dark">Tienda Virtual al Publico</h6>
                        <i className="fas fa-store text-primary" style={{ fontSize: '24px' }}></i>
                      </div>
                    </Card.Body>
                  </Card>
                </a>
              </div>
            </div>
          </div>

          {/* Sección: Configuración de la aplicación */}
          {/* <div className="mb-5">
            <h5 className="text-primary mb-4 fw-bold">Configuración de la aplicación</h5>
            <div className="row">
              <div className="col-lg-6 mb-4">
                <Link to={Helpers.config.convertUrl({ url: '/comisiones' })} className="text-decoration-none">
                  <Card className="h-100 border-0 shadow-sm bg-white">
                    <Card.Body className="p-4">
                      <div className="d-flex align-items-center justify-content-between mb-3">
                        <h6 className="mb-0 fw-bold text-dark">Idioma</h6>
                        <i className="fas fa-language text-primary" style={{ fontSize: '24px' }}></i>
                      </div>
                      <small className="text-muted">Seleccione el idioma que prefiera.</small>
                    </Card.Body>
                  </Card>
                </Link>
              </div>

              <div className="col-lg-6 mb-4">
                <Link to={Helpers.config.convertUrl({ url: '/comisiones' })} className="text-decoration-none">
                  <Card className="h-100 border-0 shadow-sm bg-white">
                    <Card.Body className="p-4">
                      <div className="d-flex align-items-center justify-content-between mb-3">
                        <h6 className="mb-0 fw-bold text-dark">Configuración general</h6>
                        <i className="fas fa-cog text-primary" style={{ fontSize: '24px' }}></i>
                      </div>
                      <small className="text-muted">Configuración de privacidad y accesibilidad.</small>
                    </Card.Body>
                  </Card>
                </Link>
              </div>
            </div>
          </div> */}
        </div>
      </div>

      {/* Estilos CSS personalizados */}
      <style jsx>{`          
                .card:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 4px 16px rgba(0,0,0,0.15) !important;
                    transition: all 0.2s ease-in-out;
                }
            `}</style>
    </div>
  )
}

export default DashboardAccount
